import { TID } from "@/lib/testIds";
import BrandLogo from "@/components/BrandLogo";
import { useLinks } from "@/admin/SiteContent";

export const Footer = () => {
  const year = new Date().getFullYear();
  const lk = useLinks();
  return (
    <footer
      data-testid={TID.footer.root}
      className="relative border-t border-white/5 bg-[#0B0B0F]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <BrandLogo size="md" />
            <p className="mt-8 text-sm leading-relaxed text-[#B6B6BE] max-w-md">
              Una città. Mille storie. Un solo standard: l&apos;eccellenza.
              PURELIFE Roleplay è l&apos;esperienza Roleplay italiana più
              curata su GTA V.
            </p>

            <div className="flex flex-wrap gap-3 mt-8">
              <a
                data-testid={TID.footer.join}
                href={lk.join}
                className="btn-gold rounded-full px-5 py-2.5 text-xs font-bold tracking-widest uppercase"
              >
                Entra ora
              </a>
              <a
                data-testid={TID.footer.discord}
                href={lk.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ghost-neon rounded-full px-5 py-2.5 text-xs font-semibold tracking-widest uppercase"
              >
                Discord
              </a>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
            <FooterCol
              title="Esplora"
              items={[
                { label: "Lore", href: "#lore" },
                { label: "Forze dell'Ordine", href: "#factions" },
                { label: "Galleria", href: "#gallery" },
                { label: "Regolamento", href: "#faq" },
              ]}
            />
            <FooterCol
              title="Community"
              items={[
                { label: "Discord", href: lk.discord, external: true },
                { label: "Regolamento", href: "#faq" },
                { label: "Supporto", href: lk.discord, external: true },
                { label: "Whitelist", href: lk.whitelist, external: true },
              ]}
            />
            <FooterCol
              title="Gioca"
              items={[
                { label: "Connetti FiveM", href: lk.join },
                { label: "Donazioni", href: lk.discord, external: true },
                { label: "Staff", href: lk.discord, external: true },
              ]}
            />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[#B6B6BE]">
            © {year} PURELIFE Roleplay. Tutti i diritti riservati. — Server
            FiveM non affiliato a Rockstar Games o Take-Two Interactive.
          </p>
          <a
            href={lk.discord}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-[#F5F5F5] hover:text-[#D4AF37] transition-colors"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] group-hover:shadow-[0_0_10px_#D4AF37] transition-shadow" />
            Designed &amp; Engineered by <span className="font-semibold">PureLife</span>
          </a>
        </div>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" />
    </footer>
  );
};

const FooterCol = ({ title, items }) => (
  <div>
    <h4 className="font-mono-pl text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-5">
      {title}
    </h4>
    <ul className="space-y-3">
      {items.map((it) => (
        <li key={it.label}>
          <a
            href={it.href}
            target={it.external ? "_blank" : undefined}
            rel={it.external ? "noopener noreferrer" : undefined}
            className="text-sm text-[#F5F5F5] hover:text-[#D4AF37] transition-colors"
          >
            {it.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
